import { EntTypeAnimalFilter } from "../../../models/filters/TypeAnimalFilter";
import { EntTypeAnimal } from "../../../models/handBooks/typeAnimal";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { Paths } from "../../../paths";

export const animalTypesApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getAnimalTypeList: builder.query<ResponseDataGet<EntTypeAnimal>, EntTypeAnimalFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.typeanimal }/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getAnimalTypeById: builder.query<ResponseDataTest<EntTypeAnimal>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.typeanimal }/${ id }`,
		method: 'GET'
	  })
	}),
	addAnimalType: builder.mutation<ResponseDataTest<EntTypeAnimal>, EntTypeAnimal>({
	  query: (body) => ({
		url: `${ Paths.handbooks.typeanimal }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editAnimalType: builder.mutation<ResponseDataTest<EntTypeAnimal>, EntTypeAnimal>({
	  query: (body,) => ({
		url: `${ Paths.handbooks.typeanimal }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteAnimalType: builder.mutation<ResponseDataTest<EntTypeAnimal>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.typeanimal }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddAnimalTypeMutation,
  useDeleteAnimalTypeMutation,
  useEditAnimalTypeMutation,
  useGetAnimalTypeListQuery,
  useLazyGetAnimalTypeListQuery
} = animalTypesApi;
